import useProjects from "./useProjects"

const useCurrentProject = () => useProjects().currentProject

export default useCurrentProject